import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React from 'react';
import { fetchDataFunc, returnCalendarExtraFunc } from '../../Shared';
import { formatDateFunc } from '../../utils/dateFormatFunc';
import { formatATMIV, formatPCHG } from '../../utils/numberFormatFunc';
import BoardViewSection from './BoardViewSection';
import StrikeNear from './StrikeNear';
import ReactGA from 'react-ga';
import styles from './OptionsBoardStyles';
import { useDispatch, useSelector } from 'react-redux';
import LightTooltip from './LightTooltip';
import { setOptionChainAction } from '../../actions/optionChainAction';
import { setAppStateAction } from '../../actions/appStateAction';

const SelectedExpration = ({ rows, changeBidAskMid }) => {
  const dispatch = useDispatch();

  const { appReducer, optionChainReducer } = useSelector((state) => state);
  const {
    expiration,
    sidepanelExpirations,
    calendarData,
    weekendErrors,
    ticker,
  } = appReducer;

  const { selectedExpration, showHideStrike, selectedDate } =
    optionChainReducer;

  const setOptionChainState = (payload) =>
    dispatch(setOptionChainAction(payload));
  const setAppState = (payload) => dispatch(setAppStateAction(payload));

  const changeExpiration = (expiration, date = '') => {
    if (expiration === 'placeholder') return;
    setAppState({ expiration });
    fetchDataFunc(ticker, expiration, date, appReducer, setAppState);
    ReactGA.event({
      category: 'ChainAction',
      action: 'Changed expiration',
      label: `${ticker} by ${expiration}`,
    });
  };

  const selectExpirationMobile = (value) => {
    setOptionChainState({ selectedExpration: true });
    changeExpiration(value, selectedDate);
  };

  return selectedExpration ? (
    <div
      style={{
        flex: 1,
        overflow: 'hidden',
      }}
    >
      {showHideStrike && <StrikeNear />}
      <BoardViewSection rows={rows} changeBidAskMid={changeBidAskMid} />
    </div>
  ) : (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'auto',
      }}
    >
      <div style={styles.mobileTxExp}>Select an Expiration</div>
      <div style={styles.divExps}>
        <TableContainer style={{ height: '100%' }}>
          <Table stickyHeader>
            <TableHead style={{ top: '0px' }}>
              <TableRow style={{ height: '7px' }}>
                <TableCell
                  style={{
                    width: '40%',
                    padding: '2px 6px 2px 10px',
                    color: 'white',
                    textAlign: 'left',
                    height: 'auto !important',
                    backgroundColor: '#505050',
                  }}
                  className="sticky"
                >
                  Exp
                </TableCell>
                <TableCell
                  style={{
                    width: '15%',
                    padding: '2px 6px 2px 6px',
                    color: 'white',
                    textAlign: 'center',
                    height: 'auto !important',
                    backgroundColor: '#505050',
                  }}
                  className="sticky"
                >
                  ATMIV
                </TableCell>
                <TableCell
                  style={{
                    width: '15%',
                    padding: '2px 6px 2px 6px',
                    color: 'white',
                    textAlign: 'center',
                    height: 'auto !important',
                    backgroundColor: '#505050',
                  }}
                  className="sticky"
                >
                  Chg
                </TableCell>
                <TableCell
                  style={{
                    width: '30%',
                    padding: '2px 6px 2px 6px',
                    color: 'white',
                    textAlign: 'center',
                    height: 'auto !important',
                    backgroundColor: '#505050',
                  }}
                  className="sticky"
                >
                  Volume
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {weekendErrors != null ? (
                <p style={{ color: 'white', textAlign: 'center' }}>
                  Unable to Fetch Data
                </p>
              ) : (
                sidepanelExpirations.map((row) => (
                  <TableRow
                    key={row.expiry}
                    style={
                      row.expiry === expiration
                        ? {
                          backgroundColor: '#00008B',
                          cursor: 'pointer',
                          height: '10px',
                        }
                        : { cursor: 'pointer', height: '10px' }
                    }
                    onClick={() => {
                      selectExpirationMobile(row.expiry);
                    }}
                  >
                    {returnCalendarExtraFunc(
                      row,
                      sidepanelExpirations,
                      calendarData
                    )[0] === '' && (
                        <TableCell
                          style={{
                            minWidth: '100px',
                            padding: '3px 0px 3px 10px',
                            color: 'white',
                            borderBottom: 'none',
                            textAlign: 'left',
                          }}
                          component="th"
                          scope="row"
                        >
                          {formatDateFunc(row.expiry)}
                        </TableCell>
                      )}
                    {returnCalendarExtraFunc(
                      row,
                      sidepanelExpirations,
                      calendarData
                    )[0] !== '' && (
                        <LightTooltip
                          placement="bottom"
                          title={
                            returnCalendarExtraFunc(
                              row,
                              sidepanelExpirations,
                              calendarData
                            )[1]
                          }
                        >
                          <TableCell
                            style={{
                              minWidth: '100px',
                              padding: '3px 0px 3px 10px',
                              color: 'white',
                              borderBottom: 'none',
                              textAlign: 'left',
                            }}
                            component="th"
                            scope="row"
                          >
                            {formatDateFunc(row.expiry) + ' '}
                            {returnCalendarExtraFunc(
                              row,
                              sidepanelExpirations,
                              calendarData
                            )[0] !== '' && (
                                <span style={{ color: '#ebcf34' }}>
                                  {
                                    returnCalendarExtraFunc(
                                      row,
                                      sidepanelExpirations,
                                      calendarData
                                    )[0]
                                  }
                                </span>
                              )}
                          </TableCell>
                        </LightTooltip>
                      )}

                    <TableCell
                      style={{
                        padding: '3px',
                        color: 'white',
                        borderBottom: 'none',
                        height: 'auto !important',
                        textAlign: 'center',
                      }}
                    >
                      {formatATMIV(row.ivol)}
                    </TableCell>
                    <TableCell
                      style={
                        row.ivol_chg > 0
                          ? {
                            padding: '3px',
                            color: '#00C943',
                            borderBottom: 'none',
                            height: 'auto !important',
                            textAlign: 'center',
                          }
                          : {
                            padding: '3px',
                            color: 'red',
                            borderBottom: 'none',
                            height: 'auto !important',
                            textAlign: 'center',
                          }
                      }
                    >
                      {formatPCHG(row.ivol_chg) === '0.0'
                        ? '-'
                        : formatPCHG(row.ivol_chg)}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: '3px',
                        paddingRight: '15px',
                        color: 'white',
                        borderBottom: 'none',
                        height: 'auto !important',
                        textAlign: 'right',
                      }}
                    >
                      {(
                        row.atm_c_vol +
                        row.atm_p_vol +
                        row.otm_c_vol +
                        row.otm_p_vol +
                        row.itm_c_vol +
                        row.itm_p_vol
                      ).toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default SelectedExpration;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/SelectedExpration.jsx